import { ComponentIds } from '@inter-ikea-core/core';
import { PlannerEcsSystem } from './System';
import PlannerProductComponent from '../components/PlannerProductComponent';
export class InSceneEventSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'InSceneEventSystem', ComponentIds.IN_SCENE_COMPONENT_ID);
        this.mandatoryComponents = [PlannerProductComponent.id];
    }
    onAdd(entity) {
        this.coreApi.emit.onInScene(entity);
    }
    onUpdate() { }
    onRemove() { }
}
//# sourceMappingURL=InSceneEventSystem.js.map